import React, { Component } from 'react';
import './styles.css';

class PopUpMailLayoutBody extends Component {
	render() {
		return <div className="pop-up-mail-layout-body">{this.props.children}</div>;
	}
}

export default PopUpMailLayoutBody;
